module.exports = __webpack_public_path__ + "mainassets/img/send.2140077f.svg";